import React from "react";

function PageHeader({ title, subtitle, actions, icon }) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-title">
          {icon}
          {title}
        </h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}

export default PageHeader;
